import { Card } from "@/components/atoms";

export const BookingPanelDetailsHeaderSkeleton = () => {
  return (
    <div className="animate-pulse p-5 pb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-6 w-6 rounded bg-gray-200" />
          <div className="h-6 w-48 rounded-md bg-gray-200" />
        </div>
        <div className="h-6 w-6 rounded bg-gray-200" />
      </div>
    </div>
  );
};

export const BookingPanelDetailsBodySkeleton = () => {
  const renderDetailFieldSkeleton = () => (
    <div className="flex items-center">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          {/* Icon placeholder */}
          <div className="h-6 w-6 rounded bg-gray-200" />
          {/* Label placeholder */}
          <div className="h-4 w-16 rounded-md bg-gray-200" />
        </div>
        <div className="min-w-0 pl-8">
          {/* Value placeholder */}
          <div className="h-4 w-32 rounded-md bg-gray-100" />
        </div>
      </div>
    </div>
  );

  // Skeleton for a card section with multiple detail fields
  const renderCardSkeleton = (fieldsCount: number = 3) => (
    <Card className="space-y-3.5 p-2.5">
      {Array.from({ length: fieldsCount }, (_, index) => (
        <div key={index}>{renderDetailFieldSkeleton()}</div>
      ))}
    </Card>
  );

  const renderActionsBarSkeleton = () => (
    <div className="px-5 py-2.5">
      <div className="flex items-center gap-2">
        <div className="h-8 w-24 rounded-md bg-gray-200" />
        <div className="h-8 w-20 rounded-md bg-gray-200" />
        <div className="h-8 w-16 rounded-md bg-gray-200" />
      </div>
    </div>
  );

  return (
    <div className="animate-pulse">
      {renderActionsBarSkeleton()}

      <div className="grid grid-cols-1 gap-2 p-5 pt-0 lg:grid-cols-2">
        <div className="space-y-2.5">
          {renderCardSkeleton(3)} {/* Basic Details */}
          {renderCardSkeleton(3)} {/* Trip Section */}
          {renderCardSkeleton(4)} {/* Passenger Section */}
          {renderCardSkeleton(1)} {/* Extras/Fees Section */}
          {renderCardSkeleton(2)} {/* Flight Section */}
          {renderCardSkeleton(2)} {/* Payment Section */}
          {renderCardSkeleton(2)} {/* Operator Section */}
        </div>

        <div className="space-y-2.5">
          {renderCardSkeleton(5)} {/* Driver Section */}
          {renderCardSkeleton(6)} {/* Vehicle Section */}
          {renderCardSkeleton(4)} {/* Notes Section */}
          {renderCardSkeleton(1)} {/* Message Section */}
          {renderCardSkeleton(1)} {/* Attachments Section */}
          {renderCardSkeleton(1)} {/* History Section */}
          {renderCardSkeleton(3)} {/* Distance Section */}
        </div>
      </div>

      <span className="sr-only">Loading booking details...</span>
    </div>
  );
};
